import { IconButton, TableRow, TableCell, Collapse, Box, SxProps, Theme } from '@mui/material';
import { Delete, KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import { useCallback, MouseEvent as ReactMouseEvent, useState } from 'react';
import { NumberText } from 'quote-detail/number-text';
import { useQuoteState } from 'shared/contexts';
import { Expense, Brands } from 'shared/types';
import { ExpenseCard } from './expense-card';

const expenseSummaryContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  cursor: 'pointer',
  '& .MuiTableCell-body': {
    '&:first-of-type': {
      paddingLeft: theme.spacing(5),
    },
  },
});
const expenseCardContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  padding: 0,
  backgroundColor: theme.palette.background.paper,
});

interface ExpenseSummaryProps {
  expense: Expense;
  index: number;
  remove: (index?: number | number[] | undefined) => void;
}

export function ExpenseSummary({ expense, index, remove }: ExpenseSummaryProps) {
  const { editMode } = useQuoteState();
  const { brand } = useParams<{ brand: Brands }>();
  const isNianticBrand: boolean = brand === 'nianticseal';
  const [open, setOpen] = useState(false);

  const removeExpense = useCallback(
    (event: ReactMouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      remove(index);
    },
    [remove, index]
  );

  return (
    <>
      <TableRow sx={expenseSummaryContainerStyles} onClick={() => setOpen(!open)}>
        <TableCell align='left'>{expense.type}</TableCell>
        <TableCell align='left'>{expense.quantity}</TableCell>
        <TableCell align='left'>
          <NumberText prefix='$' fixedDecimalScale decimalScale={isNianticBrand ? 4 : 2} text={expense.price} />
        </TableCell>
        <TableCell align='left'>
          <NumberText
            prefix='$'
            decimalScale={isNianticBrand ? 4 : 2}
            fixedDecimalScale
            text={expense.extendedPrice ? expense.extendedPrice : Number(expense.quantity) * Number(expense.price)}
          />
        </TableCell>
        <TableCell align='right'>
          <IconButton>{open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}</IconButton>
          {editMode && (
            <IconButton onClick={removeExpense}>
              <Delete />
            </IconButton>
          )}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell sx={expenseCardContainerStyles} colSpan={8}>
          <Collapse in={open} timeout='auto' unmountOnExit>
            <Box margin={3} pr={35}>
              <ExpenseCard editMode={editMode} index={index} expense={expense} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}
